// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/trackgroup.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Track } from "./track_pb.js";

/**
 * @generated from message knop.ui.v1.model.TrackGroup
 */
export class TrackGroup extends Message<TrackGroup> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: uint32 length_in_mm = 3;
   */
  lengthInMm = 0;

  /**
   * @generated from field: repeated knop.ui.v1.model.Track tracks = 4;
   */
  tracks: Track[] = [];

  constructor(data?: PartialMessage<TrackGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.TrackGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "length_in_mm", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "tracks", kind: "message", T: Track, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrackGroup {
    return new TrackGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrackGroup {
    return new TrackGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrackGroup {
    return new TrackGroup().fromJsonString(jsonString, options);
  }

  static equals(a: TrackGroup | PlainMessage<TrackGroup> | undefined, b: TrackGroup | PlainMessage<TrackGroup> | undefined): boolean {
    return proto3.util.equals(TrackGroup, a, b);
  }
}

